export default class StrapiUtils {

    static tableSortToSortString(field:string, sortString?:'ascend'|'descend'){
        let curSortString;
        if (sortString === 'ascend'){
            curSortString = 'ASC';
        } else if (sortString === 'descend'){
            curSortString = 'DESC';
        }

        if (sortString) return `${field}:${curSortString}`;
        else return undefined;
    }

}

export class StrapiQueryHandler {
    page = 0;
    queries = {};

    getCurQueryString(){
        let queryString = ''
        Object.keys(this.queries).forEach((filterString, index) => {
            if(index !== 0){
                queryString += '&'
            }
            queryString += filterString;
        })
        return queryString;
    }

    addQueryFilter(prop, filter:STRAPI_FILTERS, value){
        let filterString = `${prop}_${filter}`;
        this.queries[filterString] = value;
    }

    changePage(page:number){
        this.page = page;
    }

    incrementPage(){
        this.page += 1;
    }

    decrementPage(){
        this.page -= 1;
    }
}

export enum STRAPI_FILTERS {
    EQUAL= 'eq',
    NOT_EQUAL= 'ne',
    LESS_THAN= 'lt',
    GREATER_THAN= 'gt',
    LESS_THAN_OR_EQUAL_TO= 'lte',
    GREATER_THAN_OR_EQUAL_TO= 'gte',
    INCLUDED_IN_ARRAY= 'in',
    NOT_INCLUDED_IN_ARRAY= 'nin',
    DOES_NOT_CONTAIN= 'ncontains',
    CONTAINS= 'contains',
    CONTAINS_CASE_SENSITIVE= 'containss',
    DOES_NOT_CONTAIN_CASE_SENSITIVE= 'ncontainns',
    IS_NULL_OR_NOT_NULL= 'null'
}